import { Nullable } from 'modules/types/common';
import { consumerIdSelector } from 'store/profile/selectors';
import { Consumer, Grantor } from 'store/profile/types';
import ReduxStoreContainer from 'store/ReduxStoreContainer';

export const isPrimaryUser = (user: Nullable<Consumer | Grantor>): boolean => {
  const state = ReduxStoreContainer.getState();
  const consumerId = consumerIdSelector(state);
  return consumerId === user?.consumerId;
};

export function formatUserAddressString(props?: {
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}): string {
  const { address, city, state, zipCode } = props || {};
  const addressArr = [];
  if (address) {
    addressArr.push(`${address.trim()},`);
  }
  if (city) {
    addressArr.push(`${city.trim()},`);
  }
  if (state) {
    addressArr.push(state);
  }
  if (zipCode) {
    addressArr.push(zipCode);
  }

  return addressArr.map(str => str.trim()).join(' ');
}
